import { render, staticRenderFns } from "./FormIrmao.vue?vue&type=template&id=28bba2b5"
import script from "./FormIrmao.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormIrmao.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports